<nb-card>
    <nb-card-header class="d-flex pb-0 pe-3">
        <morva-icons class="close-cross cursor-pointer icon-18 py-1" icon="close" (click)="close()"></morva-icons>
        <span data-testid="datasource-name" class="text me-1 mb-1">{{title}}</span></nb-card-header>
    <nb-card-body>
        <p class="text">{{message}}</p>
        <div class="warning-messages my-2" *ngIf="warnings?.length > 0">
            <section class="my-1"  *ngFor="let warning of warnings">
                <morva-linear-notifiction [message]="warning"
                                          messageType="warning" defaultColor="#808080"></morva-linear-notifiction>
            </section>
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <button class="cancel" (click)="close()">
                بعداً به روزرسانی می‌کنم
            </button>
            <button class="confirm" (click)="confirm()" [nbSpinner]="submitState ==='submitting'">تایید</button>
        </div>
    </nb-card-body>
</nb-card>

